
window.options.personalisationOptions.loadingSpinner.width = 38;
window.options.personalisationOptions.loadingSpinner.height = 38;

window.options.slickOptions.slidesToShow = 3;
window.options.slickOptions.slidesToScroll = 3;

window.options.slickOptions.slidesToShow_Tablet = 2;
window.options.slickOptions.slidesToScroll_Tablet = 2;
